import { render, staticRenderFns } from "./ModifyAgent.vue?vue&type=template&id=d622a474"
import script from "./ModifyAgent.vue?vue&type=script&lang=js"
export * from "./ModifyAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports